export default __webpack_public_path__ + "static/media/image.mullai-thean.62ecf4af.png";